import {
  MODAL_SET,
  MODAL_CLEAR,
  MODAL_LOADING,
} from '../constants/modal';

export function setModal(modalName) {
  return {
    type: MODAL_SET,
    modalName,
  };
}

export function clearModal() {
  return {
    type: MODAL_CLEAR,
  };
}

export function modalLoading(loading) {
  return {
    type: MODAL_LOADING,
    loading,
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/modal.js
 **/